import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { hasAccess } from "@/lib/roles";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@apertureent.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await login(email, password);
      if (!hasAccess(u.role, "admin")) { toast.error("Admin access required"); setBusy(false); return; }
      nav("/admin");
    } catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8 flex flex-col items-center">
          <Logo size={72} color="#F7F5F0" />
          <div className="font-serif text-3xl text-white mt-3">Aperture</div>
          <div className="eyebrow" style={{ color: "#C4A265", fontSize: "0.65rem" }}>Admin Console</div>
        </div>
        <form onSubmit={submit} className="bg-white p-8 shadow-2xl rounded-sm space-y-4">
          <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required data-testid="admin-login-email"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
          <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required placeholder="Password" data-testid="admin-login-password"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
          <button disabled={busy} data-testid="admin-login-submit" className="btn-primary w-full py-3 text-xs uppercase tracking-widest rounded-sm">{busy ? "…" : "Sign in"}</button>
          <div className="pt-1 text-center">
            <Link to="/forgot-password" data-testid="admin-login-forgot-password-link" className="text-xs text-navy/60 hover:text-gold transition-colors">Forgot your password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
